// extracted by mini-css-extract-plugin
export default {"main_container":"perfil_main_container__i7Eq2"};